// Vendor imports
const classNames = require('classnames')
const PropTypes = require('prop-types')
const React = require('react')
// Shared imports
const BemEntity = require('shared/bem')
// Client V2 common imports
const tag = require('client-v2/common/utils/hyperscript')
const { useModalDepthScrollbarOffsetEffect } = require('client-v2/common/contexts/modal-depth')
// Sibling imports
const ToastsRecord = require('./record')
const ToastsNoticeRecord = require('./records/notice')

const bem = BemEntity('Toasts')

function Toasts(props) {
  const blockRef = React.useRef()
  useModalDepthScrollbarOffsetEffect(blockRef)
  const onNoticeClick = React.useCallback(
    event => {
      const { noticeId } = event.target.dataset
      props.onDismiss({ noticeId })
    },
    [props.onDismiss]
  )
  return (
    tag('div', {
      ref: blockRef,
      className: classNames(
        props.className,
        bem.block()
      )
    },
      props.notices.map(noticeProps => (
        tag(ToastsNotice, {
          key: noticeProps.id,
          onClick: onNoticeClick,
          ...noticeProps
        })
      ))
    )
  )
}

Toasts.propTypes = {
  // Values
  className: PropTypes.string,
  notices: ToastsRecord.propTypes.notices,
  // Callbacks
  onDismiss: PropTypes.func.isRequired
}

module.exports = Toasts

function ToastsNotice(props) {
  return (
    tag('div', {
      className: bem.element('notice', {
        appearance: props.appearance,
        dismissed: props.dismissed
      }),
      dataset: {
        noticeId: props.id
      },
      onClick: props.onClick
    },
      typeof props.message === 'function'
      ? props.message()
      : props.message
    )
  )
}

ToastsNotice.propTypes = {
  // Values
  ...ToastsNoticeRecord.propTypes,
  // Callbacks
  onClick: PropTypes.func.isRequired
}
